interface JourneyDaySelectorProps {
    availableJourneyDays: string[];
    currentJourneyDayId: string;
    onSelect: (journeyDayId: string) => void;
    value?: string;
}

export const JourneyDaySelector = ({ availableJourneyDays, currentJourneyDayId, onSelect, value }: JourneyDaySelectorProps) => {
    // Filter out the current journey day
    const selectableJourneyDays = availableJourneyDays.filter(dayId => dayId !== currentJourneyDayId);

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedDay = event.target.value;
        if (selectedDay) {
            onSelect(selectedDay);
        }
    };

    return (
        <select
            value={value || ''}
            onChange={handleChange}
            className="px-3 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
            <option value="">Move</option>
            {selectableJourneyDays.map((journeyDayId) => {
                const dayNumber = journeyDayId.replace('day_', '');
                return (
                    <option key={journeyDayId} value={journeyDayId}>
                        Day {dayNumber}
                    </option>
                );
            })}
        </select>
    );
};
